export default ["LEVE", "MÉDIA", "GRAVE", "GRAVÍSSIMA"];
